import React from 'react'
import { SVGIconProps } from '../types'
const SvgGridView = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <g fillRule="evenodd">
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M3 3v8h8V3zm6 6H5V5h4zm-6 4v8h8v-8zm6 6H5v-4h4zm4-16v8h8V3zm6 6h-4V5h4zm-6 4v8h8v-8zm6 6h-4v-4h4z" />
    </g>
  </svg>
)
export default SvgGridView
